import {createElement, Component, PropTypes} from 'rlink-react';
import InputBase from './InputBase';

export default class ExternalWidgetInput extends InputBase {
  hasValue (value) {
    return value && value.length > 0;

  }

  render () {
    return <div>
      {this.renderError()}
    </div>;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-forms/inputs/ExternalWidgetInput.jsx